<template>
    <div>
        <v-list dense tile>
            <v-list-item-group v-model="item" color="primary">
                <v-list-item v-for="(cat, index) in levels" :key="(cat.id)">
                    <template v-if="editOffset !== index">
                        <v-list-item-content class="pa-0" @click="startEditing(index)">
                            {{cat.name}}
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="deleteLevel(cat.id)">mdi-delete</v-icon>
                        </v-list-item-icon>
                    </template>

                    <template v-if="editOffset===index">
                        <v-list-item-content class="pa-0" @keydown.esc="cancelEditing" @keydown.enter="updateLevel(cat.id)">
                            <v-text-field dense v-model="tempValue" required> {{ tempValue }}
                            </v-text-field>
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="updateLevel(cat.id)">mdi-content-save</v-icon>
                            <v-icon medium @click="cancelEditing">mdi-close-circle</v-icon>
                        </v-list-item-icon>
                    </template>
                </v-list-item>

                <v-list-item v-for="(input, index) in inputs" :key="index">
                    <v-list-item-content class="pa-0">
                        <v-text-field dense v-model="input.one" required> {{ input.one }}
                        </v-text-field>
                    </v-list-item-content>
                    <v-list-item-icon justify="space-around">
                        <span class="group">                  
                            <v-icon medium @click="createLevel(index)" :disabled="input.one === ''">mdi-plus-circle</v-icon> 
                            <v-icon medium @click="deleteRow(index)">mdi-close-circle</v-icon>  
                        </span>                    
                    </v-list-item-icon>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <div class="text-center pt-2">
            <v-btn color="secondary" class="black--text" :disabled="disableAdd" small @click="addRow">إضافة مستوى</v-btn>
        </div>

    </div>
</template>

<script>
    import {
        GET_LEVELS,
        ADD_LEVEL,
        UPDATE_LEVEL,
        DELETE_LEVEL 
    } from '../graphql/Levels'

    export default {
        data() {
            return {
                item: -1,
                levels: '',
                disableAdd: false,
                editOffset: -1,
                tempValue: null,
                inputs: []
            }
        },
        apollo: {
            levels: {
                query: GET_LEVELS
            }
        },
        methods: {
            addRow() {
                this.disableAdd = true
                this.inputs.push({
                    one: ''
                })
            },
            deleteRow(index) {
                this.disableAdd = false
                this.inputs.splice(index, 1)
            },
            startEditing: function (index) {
                this.disableAdd = true
                this.editOffset = index;
                this.tempValue = this.levels[index].name
            },
            cancelEditing: function () {
                this.disableAdd = false
                this.editOffset = -1;
                this.tempValue = null;
            },
            createLevel(index) {
                this.$apollo.mutate({
                    mutation: ADD_LEVEL,
                    variables: {
                        name: this.inputs[index].one,
                    },
                    update: (cache, {data: {createLevel} }) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_LEVELS
                        })

                        // Create updated data
                        data.levels.push(createLevel)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_LEVELS,
                            data
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        createLevel: {
                            __typename: 'Level',
                            name: this.inputs[index].one
                        }
                    }

                }).then(({
                    data
                }) => {
                    this.disableAdd = false
                    this.inputs.splice(index, 1)
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            updateLevel(id) {
                this.$apollo.mutate({
                    mutation: UPDATE_LEVEL,
                    variables: {
                        id: id,
                        name: this.tempValue,
                    },
                    update: (cache, {data: { updateLevel }}) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_LEVELS
                        })

                        let index = data.levels.findIndex(category => category.id === updateLevel.id) 

                        let updatedLevels = [
                            ...data.levels.slice(0, index),
                            updateLevel,
                            ...data.levels.slice(index + 1)
                        ]
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_LEVELS,
                            data: updatedLevels
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        updateLevel: {
                            __typename: 'Level',
                            name: this.tempValue
                        }
                    }

                }).then(({data}) => {
                    this.disableAdd = false
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            deleteLevel(id) {
                this.$apollo.mutate({
                    mutation: DELETE_LEVEL,
                    variables: {
                        id: id
                    },
                    update: (cache, {data: { deleteLevel }}) => {
                        //First read the query you want to update
                        const data = cache.readQuery({
                            query: GET_LEVELS
                        })

                        let index = data.levels.findIndex(category => category.id === deleteLevel.id) 

                        data.levels.splice(index, 1)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_LEVELS,
                            data
                        })
                    },

                }).then(({data}) => {
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>
  .tile {
    margin: 5px;
    border-radius: 4px;
  }
  .tile:hover {
    background: green;
  }
  .tile:active {
    background: yellow;
  }
</style>